import { z } from 'zod'

export const ShiftsDeleteSchema = () => {
  return z.object({
    startAt: z.date(),
    endAt: z.date(),
    employeeId: z.number().nullable(),
    employeeSelection: z.discriminatedUnion('type', [
      z.object({
        type: z.literal('manual'),
        ids: z.array(z.number()),
      }),
      z.object({
        type: z.literal('all'),
        filters: z.record(z.unknown()).optional(),
        excludedIds: z.array(z.number()),
        includeInactive: z.boolean().optional(),
      }),
    ]),
  })
}

export type ShiftsDeleteSchemaType = z.infer<ReturnType<typeof ShiftsDeleteSchema>>
